"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountForm = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxRuntime classic */
/** @jsx jsx */
var react_1 = __importDefault(require("react"));
var mona_1 = require("@artegeie/design-system/mona");
var useAuth_1 = __importDefault(require("../../../context/useAuth"));
var useFormattedMessages_1 = __importDefault(require("../../../context/useFormattedMessages"));
var style_1 = require("../../style");
var text_1 = require("../../text");
var form_1 = require("../../form");
var AccountForm = function (_a) {
    var onDelete = _a.onDelete, onSubmit = _a.onSubmit;
    var user = (0, useAuth_1.default)().user;
    var messages = (0, useFormattedMessages_1.default)('form.profile.account');
    var onFormSubmit = (function ( /*event: MouseEvent*/) {
        // event.preventDefault()
        onDelete === null || onDelete === void 0 ? void 0 : onDelete();
    });
    return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(style_1.Spacer, __assign({ spacer: mona_1.mSpacer }, { children: (0, jsx_runtime_1.jsx)(text_1.Title, { children: messages.title }, void 0) }), void 0), (0, jsx_runtime_1.jsxs)("form", __assign({ name: "AccountForm" }, { children: [(0, jsx_runtime_1.jsx)(style_1.Spacer, __assign({ spacer: mona_1.lSpacer }, { children: (0, jsx_runtime_1.jsx)(style_1.FieldAside, __assign({ aside: (0, jsx_runtime_1.jsx)(mona_1.Link, { href: '#', onClick: onSubmit, label: messages.modify }, void 0) }, { children: (0, jsx_runtime_1.jsx)(mona_1.Textfield, { readOnly: true, value: user === null || user === void 0 ? void 0 : user.email }, void 0) }), void 0) }), void 0), (0, jsx_runtime_1.jsx)(form_1.SecondaryButton, { value: messages.deleteAccount, onClick: onFormSubmit }, void 0)] }), void 0)] }, void 0);
};
exports.AccountForm = AccountForm;
exports.default = exports.AccountForm;
